/**
 * Copyright (C) 2024-present Puter Technologies Inc.
 *
 * This file is part of Puter.
 *
 * Puter is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

/**
 * NOTE: The following translations were auto-translated from English using DeepL and google Translate.
 * Some phrases may require review by a native Norwegian Bokmål speaker.
 */

const nb = {
    name: "Norsk Bokmål",
    english_name: "Norwegian Bokmål",
    code: "nb",
    dictionary: {
        about: "Om",
        account: "Konto",
        account_password: "kontopassord",
        access_granted_to: "Tilgang gitt til",
        add_existing_account: "Legg til eksisterende konto",
        all_fields_required: "Alle felt er obligatoriske.",
        allow: "Tillate",
        apply: "Bruk",
        ascending: 'Stigende',
        associated_websites: "Tilknyttede nettsider",
        auto_arrange: 'Automatisk sortering',
        background: "Bakgrunn",
        browse: "Bla gjennom",
        cancel: "Avbryt",
        center: "Sentrer",
        change: "Endre",
        change_always_open_with: "Vil du alltid åpne denne filtypen med",
        change_desktop_background: "Endre skrivebordsbakgrunn…",
        change_email: "Endre e-post",
        change_language: "Endre språk",
        change_password: "Endre passord",
        change_ui_colors: "Endre UI-farger",
        change_username: "Endre brukernavn",
        clock_visibility: 'Klokkesynlighet',
        close: 'Lukk',
        close_all_windows: "Lukk alle vinduer",
        close_all_windows_confirm: "Er du sikker på at du vil lukke alle vinduer?",
        close_all_windows_and_log_out: 'Lukk alle vinduer og logg ut',
        color: "Farge",
        confirm: 'Bekrefte', 
        confirm_2fa_setup: 'Jeg har lagt til koden i autentiseringsappen min',
        confirm_2fa_recovery: 'Jeg har lagret gjenopprettingskodene mine på et sikkert sted',
        confirm_account_for_free_referral_storage_c2a: "Opprett en konto og bekreft e-postadressen din for å motta 1 GB gratis lagringsplass. Din venn vil også få 1 GB gratis lagringsplass.",
        confirm_code_generic_incorrect: "Feil kode.",
        confirm_code_generic_too_many_requests: "For mange forespørsler. Vennligst vent noen minutter.",
        confirm_code_generic_submit: "Send inn kode",
        confirm_code_generic_try_again: "Prøv igjen",
        confirm_code_generic_title: "Skriv inn bekreftelseskode",
        confirm_code_2fa_instruction: "Skriv inn den 6-sifrede koden fra autentiseringsappen din.",
        confirm_code_2fa_submit_btn: "Send inn",
        confirm_code_2fa_title: "Skriv inn 2FA-kode",
        confirm_delete_multiple_items: 'Er du sikker på at du vil slette disse elementene permanent?',
        confirm_delete_single_item: 'Er du sikker på at du vil slette dette elemente permanent?',
        confirm_open_apps_log_out: 'Du har åpene apper, er du sikker på at du vil logge ut?',
        confirm_new_password: "Bekreft nytt passord",
        confirm_delete_user: "Er du sikker på at du vil slette kontoen din? Alle filene og dataene dine vil bli permanent slettet. Denne handlingen kan ikke angres.",
        confirm_delete_user_title: "Slette konto?",
        confirm_session_revoke: "Er du sikker på at du vil oppheve denne økten?",
        confirm_your_email_address: "Bekreft e-postadressen din",
        contact_us: "Kontakt oss",
        contact_us_verification_required: "Du må ha en bekreftet e-postadresse for å bruke dette.",
        contain: "Inneholde",
        continue: "Fortsett",
        copy: "Kopier",
        copy_link: "Kopier lenke",
        copying: "Kopierer",
        copying_file: "Kopierer %%",
        cover: "Dekke",
        create_account: "Opprett konto",
        create_free_account: "Opprett gratis konto",
        create_desktop_shortcut: "Opprett snarvei (skrivebord)",
        create_desktop_shortcut_s: "Opprett snarveier (skrivebord)",
        create_shortcut: "Opprett snarvei",
        create_shortcut_s: "Opprett snarveier",
        credits: "Kreditering",
        current_password: "Nåværende passord",
        cut: "Klipp ut",
        clock: "Klokke",
        clock_visible_hide: "Skjul - Alltid skjult",
        clock_visible_show: "Vis - Alltid synlig",
        clock_visible_auto: "Auto - Standard, vises bare i fullskjermmodus.",
        close_all: "Lukk alle",
        created: "Opprettet",
        date_modified: "Endret dato",
        default: 'Standard',
        delete: "Slett",
        delete_account: "Slett konto",
        delete_permanently: "Slett permanent",
        deleting_file: "Sletter %%",
        deploy_as_app: "Distribuer som app",
        descending: "Synkende",
        desktop: "Skrivebord",
        desktop_background_fit: "Tilpass",
        developers: "Utviklere",
        dir_published_as_website: "%strong% er publisert på:",
        disable_2fa: "Deaktiver 2FA",
        disable_2fa_confirm: "Er du sikker på at du vil deaktivere 2FA?",
        disable_2fa_instructions: "Skriv inn passordet ditt for å deaktivere 2FA.",
        disassociate_dir: "Fjern tilknytning fra mappe",
        documents: "Dokumenter",
        dont_allow: "Ikke tillat",
        download: "Last ned",
        download_file: 'Last ned fil',
        downloading: "Laster ned",
        email: "E-post",
        email_change_confirmation_sent: "En bekreftelses-e-post har blitt sendt til din nye e-postadresse. Sjekk innboksen din og følg instruksjonene for å fullføre prosessen.",
        email_invalid: "Ugyldig e-postadresse.",
        email_or_username: "E-post eller brukernavn",
        email_required: "E-post er påkrevd.",
        empty_trash: "Tøm papirkurv",
        empty_trash_confirmation: "Er du sikker på at du vil slette alt i papirkurven permanent?",
        emptying_trash: "Tømmer papirkurv…",
        enable_2fa: "Aktiver 2FA",
        end_hard: "Avslutt hardt",
        end_process_force_confirm: "Er du sikker på at du vil tvangsavslutte denne prosessen?",
        end_soft: "Avslutt mykt",
        enlarged_qr_code: "Forstørret QR-kode",
        enter_password_to_confirm_delete_user: "Skriv inn passordet ditt for å bekrefte sletting av konto",
        error_message_is_missing: "Feilmelding mangler.",
        error_unknown_cause: "En ukjent feil har oppstått.",
        error_uploading_files: "Kunne ikke laste opp filer",
        favorites: "Favoritter",
        feedback: "Tilbakemelding",
        feedback_c2a: "Vennligst bruk skjemaet nedenfor for å sende oss din tilbakemelding, kommentarer og feilrapporter.",
        feedback_sent_confirmation: "Takk for at du kontaktet oss. Hvis du har en e-post knyttet til kontoen din, vil du høre fra oss så snart som mulig.",
        fit: "Tilpass",
        folder: "Mappe",
        force_quit: "Tvangsavslutt",
        forgot_pass_c2a: "Glemt passord?",
        from: "Fra",
        general: "Generelt",
        get_a_copy_of_on_puter: "Få en kopi av '%%' på Puter.com!",
        get_copy_link: "Få kopilenke",
        hide_all_windows: "Skjul alle vinduer",
        home: "Hjem",
        html_document: "HTML-dokument",
        hue: "Fargetone",
        image: "Bilde",
        incorrect_password: "Feil passord",
        invite_link: "Invitasjonslenke",
        item: 'element',
        items_in_trash_cannot_be_renamed: "Dette elementet kan ikke omdøpes fordi det er i papirkurven. For å omdøpe dette elementet, dra det først ut av papirkurven.",
        jpeg_image: "JPEG-bilde",
        keep_in_taskbar: "Behold i oppgavelinjen",
        language: "Språk",
        license: "Lisens",
        lightness: "Lysstyrke",
        link_copied: "Lenke kopiert",
        loading: 'Laster',
        log_in: "Logg inn",
        log_into_another_account_anyway: 'Logg inn på en annen bruker uansett',
        log_out: "Logg ut",
        looks_good: "Ser bra ut!",
        manage_sessions: "Administrer økter",
        modified: "Endret",
        move: "Flytt",
        moving_file: "Flytter %%",
        my_websites: "Mine nettsteder",
        name: "Navn",
        name_cannot_be_empty: "Navn kan ikke være tomt.",
        name_cannot_contain_double_period: "Navn kan ikke inneholde '..'.",
        name_cannot_contain_period: "Navn kan ikke inneholde '.'-tegnet.",
        name_cannot_contain_slash: "Navn kan ikke inneholde '/'-tegnet.",
        name_must_be_string: "Navn kan bare være en streng.",
        name_too_long: "Navn kan ikke være lengre enn %% tegn.",
        new: "Ny",
        new_email: "Ny e-post",
        new_folder: "Ny mappe",
        new_password: "Nytt passord",
        new_username: "Nytt brukernavn",
        no: 'Nei',
        no_dir_associated_with_site: "Ingen mappe er tilknyttet denne adressen.",
        no_websites_published: "Du har ikke publisert noen nettsteder ennå.",
        ok: "OK",
        open: "Åpne",
        new_window: "Nytt vindu",
        open_in_new_tab: "Åpne i ny fane",
        open_in_new_window: "Åpne i nytt vindu",
        open_with: "Åpne med",
        original_name: "Opprinnelig navn",
        original_path: "Opprinnelig sti",
        oss_code_and_content: "Åpen kildekodeprogramvare og innhold",
        password: "Passord",
        password_changed: "Passord endret.",
        password_recovery_rate_limit: "Du har nådd grensen for antall forespørsler; vennligst vent noen minutter. For å unngå dette i fremtiden, unngå å laste inn siden for mange ganger.",    
        password_recovery_token_invalid: "Denne lenken for passordgjenoppretting er ikke lenger gyldig.",
        password_recovery_unknown_error: "En ukjent feil har oppstått. Prøv igjen senere.",
        password_required: "Passord er påkrevd.",
        password_strength_error: "Passordet må være minst 8 tegn langt og inneholde minst én stor bokstav, én liten bokstav, ett tall og ett spesialtegn.",
        passwords_do_not_match: "`Nytt passord` og `Bekreft nytt passord` stemmer ikke overens.",
        paste: "Lim inn",
        paste_into_folder: "Lim inn i mappe",
        path: "Sti",
        personalization: "Tilpasning",
        pick_name_for_website: "Velg et navn for nettstedet ditt:",
        picture: "Bilde",
        pictures: "Bilder",
        plural_suffix: "",
        powered_by_puter_js: "Drevet av {{link=docs}}Puter.js{{/link}}",
        preparing: "Forbereder...",
        preparing_for_upload: "Forbereder opplasting...",
        print: "Skriv ut",
        privacy: "Personvern",
        proceed_to_login: "Fortsett til innlogging",
        proceed_with_account_deletion: "Fortsett med sletting av konto",
        process_status_initializing: "Initialiserer",
        process_status_running: "Kjører",
        process_type_app: "App",
        process_type_init: "Init",
        process_type_ui: "UI",
        properties: "Egenskaper",
        public: "Offentlig",
        publish: "Publiser",
        publish_as_website: "Publiser som nettsted",
        puter_description: "Puter er en personvernfokusert personlig sky der du kan samle alle filene, appene og spillene dine på ett sikkert sted, tilgjengelig fra hvor som helst, når som helst.",
        reading: "Leser %strong%",
        writing: "Skriver %strong%",
        recent: "Nylig",
        recommended: "Anbefales",
        recover_password: "Gjenopprett passord",
        refer_friends_c2a: "Få 1 GB for hver venn som oppretter og bekrefter en konto på Puter. Vennen din får også 1 GB.",
        refer_friends_social_media_c2a: "Få 1 GB gratis lagringsplass på Puter.com!",
        refresh: "Oppdater",
        release_address_confirmation: "Er du sikker på at du vil frigi denne adressen?",
        remove_from_taskbar: "Fjern fra oppgavelinjen",
        rename: "Gi nytt navn",
        repeat: "Gjenta",
        replace: 'Erstatt',
        replace_all: 'Erstatt alle',
        resend_confirmation_code: "Send bekreftelseskoden på nytt",
        reset_colors: "Tilbakestill farger",
        restart_puter_confirm: "Er du sikker på at du vil starte Puter på nytt?",
        restore: "Gjenopprett",
        save: "Lagre",
        saturation: "Metning",
        save_account: 'Lagre konto',
        save_account_to_get_copy_link: "Vennligst opprett en konto for å fortsette.",
        save_account_to_publish: "Vennligst opprett en konto for å fortsette.",
        save_session: 'Lagre økt',
        save_session_c2a: "Opprett en konto for å lagre gjeldende økt og unngå å miste arbeidet ditt.",
        scan_qr_c2a: "Skann koden nedenfor for å logge inn på denne økten fra andre enheter",
        scan_qr_2fa: "Skann QR-koden med autentiseringsappen din",
        scan_qr_generic: "Skann denne QR-koden med telefonen din eller en annen enhet",
        search: "Søk",
        seconds: "sekunder",
        security: "Sikkerhet",
        select: "Velg",
        selected: 'valgt',
        select_color: "Velg farge…",
        sessions: "Økter",
        send: "Send",
        send_password_recovery_email: "Send e-post for gjenoppretting av passord",
        session_saved: "Takk for at du opprettet en konto. Denne økten er lagret.",
        settings: "Innstillinger",
        set_new_password: "Angi nytt passord",
        share:"Dele",
        share_to: "Del",
        share_with: "Del med:",
        shortcut_to: "Snarvei til",
        show_all_windows: "Vis alle vinduer",
        show_hidden: "Vis skjulte",
        sign_in_with_puter: "Logg inn med Puter",
        sign_up: "Registrer deg",
        signing_in: "Logger inn…",
        size: "Størrelse",
        skip: 'Hopp over',
        something_went_wrong: "Noe gikk galt.",
        sort_by: "Sorter etter",
        start: "Start",
        status: "Status",
        storage_usage: "Lagringsbruk",
        storage_puter_used: "brukt av Puter",
        taking_longer_than_usual: "Dette tar litt lenger tid enn vanlig. Vennligst vent...",
        task_manager: "Oppgavebehandling",
        taskmgr_header_name: "Navn",
        taskmgr_header_status: "Status",
        taskmgr_header_type: "Type",
        'toolbar.enter_fullscreen': "Gå til fullskjerm",
        'toolbar.github': "GitHub",
        'toolbar.refer': "Henvis",
        'toolbar.save_account': "Lagre konto",
        'toolbar.search': "Søk",
        'toolbar.qrcode': "QR-kode",
        terms: "Vilkår",
        text_document: "Tekstdokument",
        tos_fineprint: "Ved å klikke på 'Opprett gratis konto' godtar du Puters {{link=terms}}tjenestevilkår{{/link}} og {{link=privacy}}personvernpolicy{{/link}}.",
        transparency: "Åpenhet",
        trash: "Papirkurv",
        two_factor: "Tofaktorautentisering",
        two_factor_disabled: "2FA deaktivert",
        two_factor_enabled: "2FA aktivert",
        type: "Type",
        type_confirm_to_delete_account: "Skriv 'bekreft' for å slette kontoen din.",
        ui_colors: "UI-farger",
        ui_manage_sessions: "Økthåndtering",
        ui_revoke: "Opphev",
        undo: "Angre",
        unlimited: "Ubegrenset",
        unzip: "Pakk ut",
        unzipping: "Pakker ut %strong%",
        upload: "Last opp",
        upload_here: "Last opp her",
        used_of: "{{used}} brukt av {{available}}",
        usage: "Bruk",
        username: "Brukernavn",
        username_changed: "Brukernavn oppdatert.",
        username_required: "Brukernavn er påkrevd.",
        versions: "Versjoner",
        videos: "Videoer",
        visibility: "Synlighet",
        yes: "Ja",
        yes_release_it: "Ja, frigi den",
        you_have_been_referred_to_puter_by_a_friend: "Du har blitt invitert til Puter av en venn!",
        zip: "Zip",
        sequencing: "Sekvenserer %strong%",
        zipping: "Zipper %strong%",

        // === 2FA Setup ===
        setup2fa_1_step_heading: 'Åpne autentiseringsappen din',
        setup2fa_1_instructions: `
            Du kan bruke hvilken som helst autentiseringsapp som støtter TOTP (Time-based One-Time Password)-protokollen.
            Det finnes mange alternativer, men hvis du er usikker, er
            <a target="_blank" href="https://authy.com/download">Authy</a>
            et godt valg for Android og iOS.`,
        setup2fa_2_step_heading: 'Skann QR-koden',
        setup2fa_3_step_heading: 'Skriv inn den 6-sifrede koden',
        setup2fa_4_step_heading: 'Kopier gjenopprettingskodene dine',
        setup2fa_4_instructions: `
            Disse gjenopprettingskodene er den eneste måten å få tilgang til kontoen din på hvis du mister telefonen eller ikke kan bruke autentiseringsappen din.
            Sørg for å lagre dem på et trygt sted.
        `,
        setup2fa_5_step_heading: 'Bekreft 2FA-oppsett',
        setup2fa_5_confirmation_1: 'Jeg har lagret gjenopprettingskodene mine på et sikkert sted',
        setup2fa_5_confirmation_2: 'Jeg er klar til å aktivere 2FA',
        setup2fa_5_button: 'Aktiver 2FA',

        // === 2FA Login ===
        login2fa_otp_title: 'Skriv inn 2FA-kode',
        login2fa_otp_instructions: 'Skriv inn den 6-sifrede koden fra autentiseringsappen din.',
        login2fa_recovery_title: 'Skriv inn en gjenopprettingskode',
        login2fa_recovery_instructions: 'Skriv inn en av gjenopprettingskodene dine for å få tilgang til kontoen.',
        login2fa_use_recovery_code: 'Bruk en gjenopprettingskode',
        login2fa_recovery_back: 'Tilbake',
        login2fa_recovery_placeholder: 'XXXXXXXX',

        // Sharing
        'Editor': 'Redaktør',
        'Viewer': 'Leser',
        'People with access': 'Personer med tilgang',
        'Share With…': 'Del med…',
        'Owner': 'Eier',
        "You can't share with yourself.": 'Du kan ikke dele med deg selv.',
        'This user already has access to this item': 'Denne brukeren har allerede tilgang til dette elementet',

        // Billing
        'billing.change_payment_method': "Endre",
        'billing.cancel': "Avbryt",
        'billing.download_invoice': "Last ned",
        'billing.payment_method': "Betalingsmetode",
        'billing.payment_method_updated': "Betalingsmetoden er oppdatert!",
        'billing.confirm_payment_method': "Bekreft betalingsmetode",
        'billing.payment_history': "Betalingshistorikk",
        'billing.refunded': "Refundert",
        'billing.paid': "Betalt",
        'billing.ok': "OK",
        'billing.resume_subscription': "Gjenoppta abonnement",
        'billing.subscription_cancelled': "Abonnementet ditt er kansellert.",
        'billing.subscription_cancelled_description': "Du vil fortsatt ha tilgang til abonnementet ditt frem til slutten av denne faktureringsperioden.",
        'billing.offering.free': "Gratis",
        'billing.offering.basic': "Grunnleggende",
        'billing.offering.pro': "Profesjonell",
        'billing.offering.professional': "Profesjonell",
        'billing.offering.business': "Bedrift",
        'billing.cloud_storage': "Skylagring",
        'billing.ai_access': "AI-tilgang",
        'billing.bandwidth': "Båndbredde",
        'billing.apps_and_games': "Apper og Spill",
        'billing.upgrade_to_pro': "Oppgrader til %strong%",
        'billing.switch_to': "Bytt til %strong%",
        'billing.payment_setup': "Betalingsoppsett",
        'billing.back': "Tilbake",
        'billing.you_are_now_subscribed_to': "Du har nå abonnert på %strong%-nivået.",
        'billing.you_are_now_subscribed_to_without_tier': "Du har nå et abonnement",
        'billing.subscription_cancellation_confirmation': "Er du sikker på at du vil kansellere abonnementet ditt?",
        'billing.subscription_setup': "Abonnementsoppsett",
        'billing.cancel_it': "Kanseller det",
        'billing.keep_it': "Behold det",
        'billing.subscription_resumed': "Abonnementet ditt på %strong% er gjenopptatt!",
        'billing.upgrade_now': "Oppgrader nå",
        'billing.upgrade': "Oppgrader",
        'billing.currently_on_free_plan': "Du bruker for øyeblikket gratisplanen.",
        'billing.download_receipt': "Last ned kvittering",
        'billing.subscription_check_error': "Det oppstod et problem med å sjekke abonnementets status.",
        'billing.email_confirmation_needed': "E-posten din er ikke bekreftet. Vi sender deg nå en kode for å bekrefte den.",
        'billing.sub_cancelled_but_valid_until': "Du har kansellert abonnementet ditt. Det vil automatisk byttes til gratisplan ved slutten av faktureringsperioden. Du blir ikke belastet igjen med mindre du abonnerer på nytt.",
        'billing.current_plan_until_end_of_period': "Gjeldende plan til slutten av faktureringsperioden.",
        'billing.current_plan': "Nåværende plan",
        'billing.cancelled_subscription_tier': "Kansellert abonnement (%%)",
        'billing.manage': "Administrer",
        'billing.limited': "Begrenset",
        'billing.expanded': "Utvidet",
        'billing.accelerated': "Akselerert",
        'billing.enjoy_msg': "Nyt %% med skylagring og andre fordeler.",
        'terms_and_conditions': "Vilkår og betingelser",
        'privacy_policy': "Personvernerklæring",
        'cookies_agree': "Ved å bruke dette nettstedet samtykker du i vår bruk av informasjonskapsler.",
        'learn_more': "Lær mer",
        'languages': "Språk",
        'contribute': "Bidra",
        'join_us': "Bli med oss",
        'description': "Åpen kildekode-app for å organisere tankene dine",
        'source_code': "Kildekode",
        'not_found': "Fant ikke siden",
        'not_found_description': "Beklager, vi finner ikke siden du leter etter.",

        // =============================================================
        // Missing translations
        // =============================================================
        "choose_publishing_option": undefined, // In English: "Choose how you want to publish your website:"
        "minimize": undefined, // In English: "Minimize"
        "reload_app": undefined, // In English: "Reload App"
        "open_trash": undefined, // In English: "Open Trash"
        "pick_name_for_worker": undefined, // In English: "Pick a name for your worker:"
        "plural_suffix": undefined, // In English: "s"
        "publish_as_serverless_worker": undefined, // In English: "Publish as Worker"
        "worker": undefined, // In English: "Worker"
        "too_many_attempts": undefined, // In English: "Too many attempts. Please try again later."
        "server_timeout": undefined, // In English: "The server took too long to respond. Please try again."
        "signup_error": undefined, // In English: "An error occurred during signup. Please try again."
        "welcome_title": undefined, // In English: "Welcome to your Personal Internet Computer"
        "welcome_description": undefined, // In English: "Store files, play games, find awesome apps, and much more! All in one place, accessible from anywhere at any time."
        "welcome_get_started": undefined, // In English: "Get Started"
        "welcome_terms": undefined, // In English: "Terms"
        "welcome_privacy": undefined, // In English: "Privacy"
        "welcome_developers": undefined, // In English: "Developers"
        "welcome_open_source": undefined, // In English: "Open Source"
        "welcome_instant_login_title": undefined, // In English: "Instant Login!"
        "alert_error_title": undefined, // In English: "Error!"
        "alert_warning_title": undefined, // In English: "Warning!"
        "alert_info_title": undefined, // In English: "Info"
        "alert_success_title": undefined, // In English: "Success!"
        "alert_confirm_title": undefined, // In English: "Are you sure?"
        "alert_yes": undefined, // In English: "Yes"
        "alert_no": undefined, // In English: "No"
        "alert_retry": undefined, // In English: "Retry"
        "alert_cancel": undefined, // In English: "Cancel"
        "signup_confirm_password": undefined, // In English: "Confirm Password"
        "login_email_username_required": undefined, // In English: "Email or username is required"
        "login_password_required": undefined, // In English: "Password is required"
        "window_title_open": undefined, // In English: "Open"
        "window_title_change_password": undefined, // In English: "Change Password"
        "window_title_select_font": undefined, // In English: "Select font…"
        "window_title_session_list": undefined, // In English: "Session List!"
        "window_title_set_new_password": undefined, // In English: "Set New Password"
        "window_title_instant_login": undefined, // In English: "Instant Login!"
        "window_title_publish_website": undefined, // In English: "Publish Website"
        "window_title_publish_worker": undefined, // In English: "Publish Worker"
        "window_title_authenticating": undefined, // In English: "Authenticating..."
        "window_title_refer_friend": undefined, // In English: "Refer a friend!"
        "desktop_show_desktop": undefined, // In English: "Show Desktop"
        "desktop_show_open_windows": undefined, // In English: "Show Open Windows"
        "desktop_exit_full_screen": undefined, // In English: "Exit Full Screen"
        "desktop_enter_full_screen": undefined, // In English: "Enter Full Screen"
        "desktop_position": undefined, // In English: "Position"
        "desktop_position_left": undefined, // In English: "Left"
        "desktop_position_bottom": undefined, // In English: "Bottom"
        "desktop_position_right": undefined, // In English: "Right"
        "item_shared_with_you": undefined, // In English: "A user has shared this item with you."
        "item_shared_by_you": undefined, // In English: "You have shared this item with at least one other user."
        "item_shortcut": undefined, // In English: "Shortcut"
        "item_associated_websites": undefined, // In English: "Associated website"
        "item_associated_websites_plural": undefined, // In English: "Associated websites"
        "no_suitable_apps_found": undefined, // In English: "No suitable apps found"
        "window_click_to_go_back": undefined, // In English: "Click to go back."
        "window_click_to_go_forward": undefined, // In English: "Click to go forward."
        "window_click_to_go_up": undefined, // In English: "Click to go one directory up."
        "window_title_public": undefined, // In English: "Public"
        "window_title_videos": undefined, // In English: "Videos"
        "window_title_pictures": undefined, // In English: "Pictures"
        "window_title_puter": undefined, // In English: "Puter"
        "window_folder_empty": undefined, // In English: "This folder is empty"
        "manage_your_subdomains": undefined, // In English: "Manage Your Subdomains"
        "open_containing_folder": undefined, // In English: "Open Containing Folder"
    }
};

export default nb;
